import { Info, ExternalLink } from 'lucide-react';
import { Card } from '@/components/ui/card';

const IMPORTANT_LINKS = [
  { label: 'Organisation Structure', url: 'https://drive.google.com/file/d/1weqXfnx6p5NAI22xLbfJHP6Dg7vlldVf/view?usp=drive_link' },
  { label: 'List of Holidays 2026', url: 'https://drive.google.com/file/d/1Oie9yFsOAuz45YQz8aN_0xbxfSfnGYsy/view?usp=drive_link' },
  { label: 'List of Holidays 2027', url: 'https://drive.google.com/file/d/1B_iTY-1rrZA0PZ5u57eYsMamB9Y2D4je/view?usp=drive_link' },
];

const ImportantInformation = () => (
  <div className="space-y-6">
    <div>
      <h1 className="text-3xl font-bold flex items-center gap-2">
        <Info className="h-7 w-7" />
        Important Information
      </h1>
      <p className="text-muted-foreground mt-1">Click a link to open the PDF in a new tab</p>
    </div>
    <Card className="border-border/60 bg-white p-6">
      <ul className="space-y-4">
        {IMPORTANT_LINKS.map((item, idx) => (
          <li key={item.url}>
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-2 text-xl text-blue-700 hover:underline break-words"
              data-testid={`important-link-${idx}`}
            >
              <span>{item.label}</span>
              <ExternalLink className="h-4 w-4 shrink-0 mt-2" />
            </a>
          </li>
        ))}
      </ul>
    </Card>
  </div>
);

export default ImportantInformation;
